<template>
    <section class="padding-vertical-content" id="recinto">
        <ContentOrLoading :style="loading ? 'padding: 200px;' : ''">
            <div class="container" v-if="!loading">
                <div class="row" v-if="!seccion_seleccionada">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">{{ $t('partido.pinchando_mapa') }}</h2>
                    </div>

                    <div class="col-12">
                        <transition name="fade" mode="out-in">
                            <div class="row" key="secciones" id="secciones">
                                <div class="col-lg-12">
                                    <div class="lightgray-content">
                                        <SvgSectionsComponent
                                            :secciones="secciones"
                                            @clickZona="seccionSeleccionada"
                                        />												
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <div v-else>
                    <template v-if="! seccion_seleccionada.tiene_secciones">
                        <div class="col-12 justify-content-between d-flex">
                            <span class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.elige_asientos') }}</span>
                            <button @click="volver" class="h6 button small-button m-0"><i class="fa fa-redo"></i> Volver</button>
                        </div>

                        <b-col cols="12" class="pt-3">
                            <b-breadcrumb>
                                <b-breadcrumb-item 
                                    v-for="(item, index) in breadcrumbs" 
                                    :key="index" 
                                    @click="breadcrumbs.length -1 == index ? null : goTo(item, index)"
                                    :active="breadcrumbs.length -1 == index"
                                >
                                    {{ item.name }}
                                </b-breadcrumb-item>
                            </b-breadcrumb>
                        </b-col>

                        <div class="col-12" v-show="!cargando_zonas">
                            <transition name="fade" mode="out-in">
                                <div class="row" key="seccion" id="zonas"> 
                                    <b-col cols="12">
                                        <h3 class="subtitle h3 light mb-3 ">A) {{ $t('partido.pinchando_mapa') }}:</h3>
                                    </b-col>
                                    <div class="col-lg-8" v-if="!cargando_zonas">
                                        <div class="lightgray-content">
                                            <SvgSectionComponent
                                                :zonas="zonas_formated"
                                                :seccion="seccion_seleccionada"
                                                @clickZona="regionFinalSeleccionada"
                                                @cargado="cargando_zonas = false"
                                            />												
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <h3 class="subtitle h3 light mb-3 ">B) {{ $t('partido.tabla') }}:</h3>
                                        <div class="lightgray-content p-2 pb-0">
                                            <TablaSectoresComponent 
                                                :zonas="zonas_formated" 
                                                @clickZona="regionFinalSeleccionada"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div v-if="cargando_zonas" class="col-12 text-center" style="height: 400px">
                            <LoaderComponent/>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-12 justify-content-between d-flex">
                            <h2 class="m-0 h1 text-uppercase text-center pb-3">{{ $t('partido.pinchando_mapa') }}</h2>
                            <button @click="volver" class="h6 button small-button m-0"><i class="fa fa-redo"></i> Volver</button>
                        </div>

                        <b-col cols="12" class="pt-3">
                            <b-breadcrumb>
                                <b-breadcrumb-item 
                                    v-for="(item, index) in breadcrumbs"
                                    :key="index" 
                                    @click="breadcrumbs.length -1 == index ? null : goTo(item, index)"
                                    :active="breadcrumbs.length -1 == index"
                                >
                                    {{ item.name }}
                                </b-breadcrumb-item>
                            </b-breadcrumb>
                        </b-col>

                        <div class="col-12" v-show="!cargando_zonas">
                            <transition name="fade" mode="out-in">
                                <div class="row" key="secciones" id="zonas">
                                    <div class="col-lg-12">
                                        <div class="lightgray-content">
                                            <SvgSectionComponent
                                                :zonas="secciones"
                                                :seccion="seccion_seleccionada"
                                                @clickZona="seccionSeleccionada"
                                                @cargado="cargando_zonas = false"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div v-if="cargando_zonas" class="col-12 text-center" style="height: 400px">
                            <LoaderComponent/>
                        </div>
                    </template>
                </div>
            </div>
        </ContentOrLoading>
    </section>
</template>

<script>
    import SvgSectionsComponent from './SvgSectionsComponent.vue';
    import SvgSectionComponent from './SvgSectionComponent.vue';
    import TablaSectoresComponent from '@/components/frontend/abonos/nuevo/TablaSectoresComponent';

    export default {
        data() {
            return {
                loading: false,
                seccion_seleccionada: false,
                secciones: [],
                breadcrumbs: [],
                cargando_zonas: false,
                zonas: []
            }
        },
        created() {
            this.getSecciones();

            this.breadcrumbs.push({
                name: 'Inicio'
            })
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            zonas_formated() {
                var array = [];
                for(var zona in this.zonas) {
                    array.push(this.zonas[zona]);
                    var disponible = array[zona].tipos_abonos.length > 0 && array[zona].esta_disponible && array[zona].libres > 0 ? true : false;
                    array[zona].esta_disponible = disponible;
                }

                return array;                
            },
        },
        methods: {
            getSecciones() {
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.secciones'), {
                    filters: {},
                    recinto_id: this.recinto.id,
                    lista_abonado_id: this.lista_abonados.id
                }).then(res => {
                    this.secciones = res.data.data;
                    this.loading = false;
                });
            },
            seccionSeleccionada(seccion) {
                this.breadcrumbs.push({
                    name: seccion.name,
                    id: seccion.id,
                    tiene_secciones: seccion.tiene_secciones
                })
                this.cargando_zonas = true;
                this.zonas = [];
                this.getSeccionRegiones(seccion);            
                this.seccion_seleccionada = seccion;
            },
            getSeccionRegiones(seccion) {
                this.cargando_zonas = true;
                const params = {
                    filters: {},
                    seccion_id: seccion.id,
                    recinto_id: this.recinto.id,
                    lista_abonado_id: this.lista_abonados.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.secciones.zonas'), params).then(res => {
                    if(! seccion.tiene_secciones) {
                        this.zonas = this.zonas.concat(res.data.data);
                    } else {
                        this.secciones = res.data.data;
                    }
                
                }).finally(() => {
                    this.cargando_zonas = false;
                });
            },
            regionFinalSeleccionada(zona) {
                this.$emit('terminar', zona);
            },
            volver() {
                let index = this.breadcrumbs.length -2;
                this.goTo(this.breadcrumbs[index], index)
            },
            goTo(item, index) {
                if(item.name == 'Inicio') {
                    this.reset();
                } else {
                    this.breadcrumbs.splice(index);
                    this.seccionSeleccionada(item);
                }
            },
            reset() {
                this.breadcrumbs = [{
                    name: 'Inicio'
                }];
                this.seccion_seleccionada = null;
                this.zonas = [];
                this.getSecciones();
            },
        },
        components: {
            SvgSectionsComponent, SvgSectionComponent, TablaSectoresComponent
        }
    }
</script>